// To fix issue from AlgoliaSearch Javascript Client : https://github.com/algolia/algoliasearch-client-javascript/issues/691
(window as any).process = {
  env: { DEBUG: undefined },
};

// installDropListMonkeyPatch();
